import { ReactElement, useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'

export const createWrapperAndAppendToBody = (
    wrapperId: string
): HTMLDivElement => {
    const wrapperElement = document.createElement('div')
    wrapperElement.setAttribute('id', wrapperId)
    document.body.appendChild(wrapperElement)
    return wrapperElement
}

interface ReactPortalProps {
    children: ReactElement
    wrapperId: string
}

const ReactPortal = ({
    children,
    wrapperId = 'react-portal-wrapper',
}: ReactPortalProps): any => {
    const [wrapperElement, setWrapperElement] = useState<HTMLElement | null>(
        null
    )
    useLayoutEffect(() => {
        let element = document.getElementById(wrapperId)
        let systemCreated = false
        /*
         * if element not found with wrapperId or wrapperId is not provided,
         * create and append to the body.
         */
        if (!element) {
            systemCreated = true
            element = createWrapperAndAppendToBody(wrapperId)
        }
        setWrapperElement(element)

        // remove programmatically created portal element on unmount
        return () => {
            if (systemCreated) {
                element?.parentNode?.removeChild(element)
            }
        }
    }, [wrapperId])

    if (wrapperElement === null) return null

    return createPortal(children, wrapperElement)
}

export default ReactPortal
